<template>
  <div class="wrapper">
    <WindowResize />
    <router-view />
    <footer class="fixed-bottom-container">
      <footer-container />
    </footer>
  </div>
</template>

<script>
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import '@/assets/css/all.css';
import '@/assets/css/solid.css';
import '@/assets/css/style.css';
import '@/assets/css/mobile.css';
import 'vue-select/dist/vue-select.css';

import WindowResize from '@/views/template/components/WindowResize';
import { FooterContainer } from './components/footer';
export default {
  name: 'WelcomeLayout',
  components: {
    WindowResize,
    FooterContainer,
  },
};
</script>

<style>
html {
  height: 100% !important;
}

body {
  height: 100% !important;
}

.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.grecaptcha-badge {
  display: none !important;
}
</style>
